<template>
  <div
    class="vhp-header" 
    :class="{ dynamic: dynamic, [mode]: mode }"
  >
    <div
      class="vhp-header-content container-width"
      v-click-outside="onClickOutside"
    >
      <span class="vhp-header-title">
        <a href="/" @click="scrollTop">
          <img
            v-if="mode === 'white'"
            class="logo"
            alt="logo"
            src="@/assets/image/logo-color.png"
            height="20"
          />
          <img
            v-else
            class="logo"
            alt="logo"
            src="@/assets/image/logo-color-w.png"
            height="20"
          />
        </a>
      </span>

      <nav class="vhp-header-menu-wrap">
        <ul class="vhp-header-menu" @mouseleave="selectedMenu = null">
          <li
            v-for="menu in menus"
            :key="menu.key"
            @mouseover="hoverMenu(menu)"
            class="main-menu"
          >
            <router-link
              :to="menu.path"
              :class="{ active: $route.path.indexOf(menu.key) !== -1 }"
            >
              <span
                class="menu-title"
                :class="{ [mode]: mode }"
                >{{ $t(menu.text) }}</span
              >
            </router-link>

            <ul
              class="vhp-header-submenu"
              v-if="selectedMenu === menu && menu.childrens.length > 0"
            >
              <li v-for="submenu in selectedMenu.childrens" :key="submenu.key">
                <a
                  v-if="submenu.outlink"
                  @click="(selectedMenu = null), $utils.openLink(submenu.path)"
                  class="outlink"
                >
                  {{ $t(submenu.text) }}
                  <img
                    alt="external-link"
                    src="@/assets/image/external-link.svg"
                    height="12"
                    style="margin-left: 6px"
                  />
                </a>
                <router-link
                  v-else
                  :to="submenu.path"
                  @click="selectedMenu = null"
                  :class="{highlight: isSubmenuActive(submenu.path)}"
                >
                  {{ $t(submenu.text) }}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>

        <div class="vhp-header-allmenu" v-if="menuIndex === 0">
          <ul class="vhp-header-allmenu-item-wrap container-width desktop-hide">
            <li v-for="menu in menus" :key="menu.key">
              <div>
                <router-link :to="menu.path" @click="allMenu = false">
                  <strong>{{ $t(menu.text) }}</strong>
                </router-link>
              </div>
              <div
                class="header-allmenu-item"
                v-for="submenu in menu.childrens"
                :key="submenu.key"
              >
                <a
                  v-if="submenu.outlink"
                  @click="(menuIndex = -1), $utils.openLink(submenu.path)"
                  class="outlink"
                >
                  {{ $t(submenu.text) }}
                  <img
                    alt="external-link"
                    src="@/assets/image/external-link.svg"
                    height="12"
                    style="margin-left: 6px"
                  />
                </a>
                <router-link v-else :to="submenu.path" @click="menuIndex = -1">
                  {{ $t(submenu.text) }}
                </router-link>
              </div>
            </li>
          </ul>

          <div class="vhp-header-allmenu-item-wrap desktop-show">
            <ul v-for="(menu, idx) in menus" :key="menu.key"
              
            >
              <li
                data-aos-duration="500"
                :data-aos-delay="idx * 100"
                data-aos-offset="100"
                data-aos="fade-right"
                data-aos-easing="ease-in-out"
              >
                <div class="parent-item">
                  <a
                    v-if="menu.childrens.length > 0"
                    @click="onClickArrow(idx)"
                    :class="{ active: activeMenuIndex === idx }"
                  >
                    <strong>{{ $t(menu.text) }}</strong>
                    <div class="arrow" v-if="menu.childrens">
                      <span />
                      <span />
                    </div>
                  </a>

                  <router-link :to="menu.path" @click="menuIndex = -1" v-else>
                    <strong>{{ $t(menu.text) }}</strong>
                  </router-link>
                </div>

                <div
                  v-if="menu.childrens.length > 0 && activeMenuIndex === idx"
                  :class="{ active: activeMenuIndex === idx }"
                >
                  <div
                    class="header-allmenu-item"
                    v-for="submenu in menu.childrens"
                    :key="submenu.key"
                  >
                    <a
                      v-if="submenu.outlink"
                      @click="(selectedMenu = null), openLink(submenu.path)"
                      class="outlink"
                    >
                      {{ $t(submenu.text) }}
                      <img
                        alt="external-link"
                        src="@/assets/image/external-link.svg"
                        height="12"
                        style="margin-left: 6px"
                      />
                    </a>
                    <router-link
                      v-else
                      :to="submenu.path"
                      @click="menuIndex = -1"
                    >
                      {{ $t(submenu.text) }}
                    </router-link>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="vhp-header-search" v-if="menuIndex === 1">
          <span
            class="search-wrap container-width"
            data-aos-duration="200"
            data-aos="zoom-in-down"
            data-aos-easing="ease-in-out"
          >
            <div class="vhp-input full">
              <input
                class="append-icon"
                type="text"
                name="search"
                id="search"
                v-model="searchKeyword"
                :placeholder="$t('검색어입력')"
                @keyup.enter="searching()"
              />
              <img
                class="icon"
                src="@/assets/image/search.svg"
                width="20"
                height="20"
                alt="magnify"
              />
            </div>
          </span>
        </div>
      </nav>

      <div class="vhp-header-util" :class="{ [mode]: mode }">
        <button @click="setLanguage()" class="vhp-button round globe">
          <span class="add">{{ $i18n.locale }}</span>
          <!-- <img
            alt="globe"
            src="@/assets/image/globe2.svg"
            width="20"
            height="20"
          /> -->
        </button>

        <button
          @click="openMenu(1)"
          class="vhp-button round"
          :class="menuIndex === 1 ? 'on' : ''"
        >
          <img
            alt="globe"
            src="@/assets/image/search.svg"
            width="20"
            height="20"
          />
        </button>

        <div
          class="vhp-header-menu-btn vhp-button round"
          :class="{ on: menuIndex === 0 }"
          @click="openMenu(0)"
        >
          <span class="menu-btn-line"></span>
          <span class="menu-btn-line"></span>
          <span class="menu-btn-line"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "click-outside-vue3";

export default {
  name: "vhpHeader",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    menus: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dynamic: {
      type: Boolean,
      default: false,
    },
    style: {
      type: Object,
    },
    headerMode: {
      type: String,
      default: "white",
    },
  },
  data() {
    return {
      selectedMenu: null,
      searchMenu: false,
      activeMenuIndex: -1,
      searchKeyword: "",
      menuIndex: -1,
      mode: this.headerMode,
    };
  },

  watch: {
    menuIndex() {
      this.mode = this.headerMode;
      if (this.menuIndex === 0) {
        document.body.style.overflowY = "hidden";
        this.mode = "white";
      } else if (this.menuIndex === 1) {
        document.body.style.overflowY = "hidden"; 
        this.mode = "white";
      } else {
        document.body.style.overflowY = "auto";
      }
    },

    "$route.path"() {
      this.menuIndex = -1;
    },

    headerMode() {
      this.mode = this.headerMode;
    }
  },

  methods: {
    setLanguage() {
      //임시
      // this.$route.query.lang = "kr"
      // alert('현재 영문 페이지 준비중입니다. 빠른 시일 내에 준비하겠습니다.')

      this.$route.query.lang = this.$i18n.locale === "kr" ? "en" : "kr";
      let route = this.$router.resolve({
        path: this.$route.path,
        query: this.$route.query,
      });

      window.open(route.href, "_self");
    },
    openMenu(index) {
      if (this.menuIndex === index) {
        this.menuIndex = -1;
      } else {
        this.menuIndex = index;
      }
    },
    searching() {
      this.$route.query["keyword"] = this.searchKeyword;
      let route = this.$router.resolve({
        path: "/search",
        query: this.$route.query,
      });

      window.open(route.href, "_self");
      this.searchKeyword = "";
      this.searchMenu = false;
    },
    hoverMenu(menu) {
      if (this.menuIndex === 0) return;
      this.selectedMenu = menu;
    },
    onClickOutside() {
      this.menuIndex = -1;
    },
    onClickArrow(idx) {
      if (idx === this.activeMenuIndex) {
        this.activeMenuIndex = -1;
        return;
      }
      this.activeMenuIndex = idx;
    },
    scrollTop() {
      window.scroll({
        left: 0,
        top: 0,
      });
    },
    isSubmenuActive(submenuPath) {
      const current = this.$route.path;
      // 정확히 일치하거나, submenuPath + '/' 로 시작하는 경우만 활성화
      return current === submenuPath || current.startsWith(submenuPath + '/');
    },
  },
};
</script>

<style lang="scss" src="./vhpHeader.scss"></style>
